/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MoneyIcon = ({ width = 24, height = 24, hidden = false, title = 'Money' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="22" cy="14" r="4" />
    <path
      d="M8 21V7a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Zm26-9.343A6.016 6.016 0 0 1 30.343 8H13.657A6.015 6.015 0 0 1 10 11.657v4.686A6.016 6.016 0 0 1 13.657 20h16.686A6.015 6.015 0 0 1 34 16.343Z"
    />
    <path d="M33 26H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v16h28v1a1 1 0 0 1-1 1Z" />
    <path d="M29 30H1a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h1v16h28v1a1 1 0 0 1-1 1Z" />
  </svg>`;
};
